import React from "react";

const gapContextStructure = {
  userPropsKpi: {
    value: null,
  },
    gapElementList: {
      value: null,
      set:  () => {},
  },
  dataserieFullData: {
      value: {
        revisionDataserieFullList: null,
        gapFishboneList: null,
        fireUpdateLastAction: true
      },
      set:  () => {},
  },
  gapRevisionDataserieList: {
      value: null,
      set:  () => {},
  }
}
export default React.createContext(gapContextStructure);


